import { notifications } from '@mantine/notifications';
import { updateDataSetFiles } from '../../apiClient';
import { useEntityQueryUpdate } from '../../../hooks/useEntityQueryUpdate';
import { useMutation } from '@tanstack/react-query';

const useUpdateDataSetFiles = () => {
    const entityUpdater = useEntityQueryUpdate();

    const mutation = useMutation({
        mutationKey: 'update_dataset_files',
        mutationFn: (model) => updateDataSetFiles(model),
        onSuccess: (data) => {
            entityUpdater([['data_sets'], ['data_set', data.id]], data);
            notifications.show({
                title: 'Success',
                message: 'Successfully updated data set files.',
                color: 'green',
            });
        },
        onError: (error) => {
            notifications.show({
                title: 'Error',
                message: error.message,
                color: 'red',
            });
        },
    });
    return mutation;
};
export default useUpdateDataSetFiles;
